import styled from 'styled-components';
import { Stack } from 'common/ui/Layout';
import { Colors } from 'styles';
import { rootTheme } from 'theme/rootTheme';

export const RightDrawerPreviewBox = styled(Stack)`
  background-color: ${Colors.gray4};
  border-radius: ${rootTheme.radius.sm};
  overflow: auto;
`;
